
const baseURL= process.env.REACT_APP_API_BASE_URL || "https://atci.lkm.eitacademy.accenture.com/ips-apis"
export default baseURL;